"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressBarKeys = exports.logMessageKeys = void 0;
exports.logMessageKeys = {
    startExecuteDriver: "driver.botAadApp.log.startExecuteDriver",
    successExecuteDriver: "driver.botAadApp.log.successExecuteDriver",
    failExecuteDriver: "driver.botAadApp.log.failExecuteDriver",
    successCreateBotAad: "driver.botAadApp.log.successCreateBotAad",
    useExistingBotAad: "driver.botAadApp.log.useExistingBotAad",
    startCreateBotAadApp: "botRegistration.log.startCreateBotAadApp",
    successCreateBotAadApp: "botRegistration.log.successCreateBotAadApp",
    skipCreateBotAadApp: "botRegistration.log.skipCreateBotAadApp",
    deleteAadAfterDebugging: "driver.aadApp.log.deleteAadAfterDebugging",
};
exports.progressBarKeys = {
    creatingBotAadApp: "botRegistration.ProgressBar.creatingBotAadApp",
};
//# sourceMappingURL=constants.js.map